import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'
import {doREQUEST_ERROR, doREQUEST_COMPLETE} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE = 'REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE'
export const doREQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE = createDoRequestAction(
  REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE,
)

export const requestScheduleTimeSlotListGenerateActionCreators = {
  doREQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE,
}

export function* requestScheduleTimeSlotListGenerate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*requestScheduleTimeSlotListGenerate')

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        scheduleIdList: v.array().items(v.string().uuid().exist()).min(1).exist(),
        absoluteStartDate: v.date().exist(),
        startDate: v.date().exist(),
        endDate: v.date().exist(),
        baseSeed: v.string().exist(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {requestId, ...data} = payload
  const accessToken = yield call(getToken)
  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/schedule-time-slot-list-generate`,
    accessToken,
    data,
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE,
          fromPayload: payload,
          requestId: requestId,
          url: '/v1/web/schedule-time-slot-list-generate',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE,
        requestId: requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* scheduleTimeSlotListGenerateSaga() {
  yield takeEvery(REQUEST_SCHEDULE_TIME_SLOT_LIST_GENERATE, requestScheduleTimeSlotListGenerate)
}
